/**
 * Valley Eats Driver Portal - Main Entry Point
 */

import './styles/main.css';
import { initRouter } from './utils/router';
import { initAuth } from './utils/auth';

// Initialize application
async function init() {
  console.log('Initializing Valley Eats Driver Portal...');

  try {
    // Check authentication state
    const isAuthenticated = await initAuth();

    if (!isAuthenticated) {
      // Show login page
      console.log('User not authenticated, showing login page');
      const { renderLoginPage } = await import('./pages/login');
      renderLoginPage();
    } else {
      // Initialize router for authenticated users
      console.log('User authenticated, initializing router');
      initRouter();
    }
  } catch (error) {
    console.error('Failed to initialize app:', error);
    showError('Failed to initialize application. Please refresh the page.');
  }
}

// Error display utility
function showError(message: string) {
  const app = document.getElementById('app');
  if (app) {
    app.innerHTML = `
      <div class="container" style="padding-top: 100px;">
        <div class="card" style="max-width: 500px; margin: 0 auto; text-align: center;">
          <div style="margin-bottom: 16px;"><ion-icon name="warning-outline" style="font-size:20px;vertical-align:middle;"></ion-icon></div>
          <h1 style="margin-bottom: 16px;">Something went wrong</h1>
          <p style="color: var(--slate); margin-bottom: 24px;">${message}</p>
          <button class="btn btn-primary" onclick="location.reload()">
            Reload Page
          </button>
        </div>
      </div>
    `;
  }
}

// Start the app
init();
